import { useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import Actionbar from 'src/components/common/actionbar/Authactionbar';
import { Message } from 'src/components/common/form/Message';
import useUiuxStore from 'src/store/useUiuxStore';
import { useMouseContent } from 'src/utils/mouse/mouseContent';
import { Content_TQC2010_R01 } from './Content_TQC2010_R01';
import { TQC2010_R01DetailDto, TQC2010_R01HeaderDto } from './Dto_TQC2010_R01';
import { DetailTable_TQC2010_R01 } from './DetailTable_TQC2010_R01';
import { Info_TQC2010_R01 } from './Info_TQC2010_R01';
import { SearchSection_TQC2010_R01 } from './SearchSetion_TQC_2010_R01';
import { Table_TQC2010_R01 } from './Table_TQC2010_R01';
import { useTQC2010_R01Store } from './Store_TQC2010_R01';

const TABLE_INFO_RESIZER = {
	code: 'TQC2010_R01',
	type: 'height' as const,
	storageKey: 'TQC2010_R01-table-info-split-height',
	min: 25,
	max: 80,
	default: 55,
};

const INFO_DETAIL_RESIZER = {
	code: 'TQC2010_R01',
	type: 'height' as const,
	storageKey: 'TQC2010_R01-info-detail-split-height',
	min: 15,
	max: 70,
	default: 35,
};

export const Container_TQC2010_R01 = () => {
	const { setMessage } = useUiuxStore();
	const gridRef = useRef<AgGridReact<TQC2010_R01HeaderDto>>(null);
	const detailGridRef = useRef<AgGridReact<TQC2010_R01DetailDto>>(null);
	const containerRef = useRef<HTMLDivElement>(null);
	const bottomPanelRef = useRef<HTMLDivElement>(null);
	const infoPanelRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);
	const isInfoDetailResizing = useRef(false);

	const { splitValue, handleMouseDown } = useMouseContent({
		resizer: TABLE_INFO_RESIZER,
		isResizing,
		containerRef,
	});

	const {
		splitValue: infoDetailSplitValue,
		handleMouseDown: handleInfoDetailMouseDown,
	} = useMouseContent({
		resizer: INFO_DETAIL_RESIZER,
		isResizing: isInfoDetailResizing,
		containerRef: bottomPanelRef,
		infoRef: infoPanelRef,
	});

	const { initData } = useTQC2010_R01Store();

	const { fetchData, handleTableRowClick, handleSaveClick } = Content_TQC2010_R01({ setMessage });

	return (
		<div className="content-container">
			<Actionbar
				onFetchClick={fetchData}
				onSaveClick={handleSaveClick}
				onInitClick={initData}
			/>
			<SearchSection_TQC2010_R01 />
			<div
				className="flex flex-col flex-1 p-[12px] gap-[4px] min-h-0"
				ref={containerRef}
			>
				<div style={{ height: `${splitValue}%` }}>
					<Table_TQC2010_R01
						gridRef={gridRef}
						onRowClick={handleTableRowClick}
					/>
				</div>

				<div
					className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300 flex-shrink-0"
					onMouseDown={(e) => handleMouseDown('UD', e.nativeEvent)}
					onDragStart={(e) => e.preventDefault()}
				/>

				<div
					ref={bottomPanelRef}
					className="flex flex-col gap-[4px]"
					style={{ height: `${100 - splitValue}%` }}
				>
					<div
						ref={infoPanelRef}
						style={{ height: `${infoDetailSplitValue}%`, maxHeight: `${infoDetailSplitValue}%` }}
					>
						<Info_TQC2010_R01 />
					</div>
					<div
						className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300"
						onMouseDown={(e) => handleInfoDetailMouseDown('UD', e.nativeEvent)}
					/>
					<div style={{ height: `${100 - infoDetailSplitValue}%` }}>
						<DetailTable_TQC2010_R01 detailGridRef={detailGridRef} />
					</div>
				</div>
			</div>
			<Message />
		</div>
	);
};
